import { useNavigate } from "react-router-dom";
import { Container, Image } from "semantic-ui-react";
import Header from "components/header";

import { GetAllProfiles, GetHeroImage } from "./profileLoader";
import { getMainHero } from "./utils";

const excludePlayers = ["Kristian", "Bendik"];

const PlayerRanks = () => {
    const navigate = useNavigate();

    const profiles = GetAllProfiles();

    const sortedPlayers = Object.entries(profiles).sort(
        ([, a], [, b]) => b.elo - a.elo
    );

    const onPlayerClick = (playerName: string) => {
        window.scrollTo(0, 0);
        navigate(`/players/${playerName}`);
    }

    const getPlayerWinRate = (player: any) => {
        const rate = player.win_count /
            (player.win_count + player.lose_count);
        return Number(rate * 100).toFixed(0) + "%";
    }

    return (
        <div className="melee-wrapper">
            <Container
                className="regular-text"
                style={{ paddingTop: 10, paddingBottom: 10 }}
            >

                <Header
                    helmet={"Player Ranks"}
                    rightMenu={
                        <button
                            className="melee-inline-button"
                            onClick={() => navigate("/")}
                        >
                            Back
                        </button>
                    }
                />

                <div style={{ marginTop: "4em", marginBottom: "4em" }}>
                    <h2 style={{ marginBottom: '3em' }}>Player Ranks</h2>

                    <div >
                    </div>

                    <table className="melee-stats-table striped">
                        <thead>
                            <tr>
                                <th style={{ textAlign: "left", maxWidth: '2em' }}>
                                    <h3 className="hide-mobile">Rank</h3>
                                </th>
                                <th style={{ textAlign: "left" }}>
                                    <h3>Player</h3>
                                </th>
                                <th>
                                    <h3>
                                        <span className="hide-mobile">Wins</span>
                                        <span className="hide-desktop" style={{ marginRight: '5px' }}>W</span>
                                    </h3>

                                </th>
                                <th>
                                    <h3>
                                        <span className="hide-mobile">Losses</span>
                                        <span className="hide-desktop" style={{ marginRight: '5px' }}>L</span>
                                    </h3>
                                </th>
                                <th>Win Rate</th>
                                <th>
                                    <h3>Rating</h3>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {sortedPlayers.map(([player, stats], index) => (
                                excludePlayers.includes(player) ? null :
                                <tr key={player}>
                                    <td>{index + 1}</td>
                                    <td
                                        onClick={() => onPlayerClick(player)}
                                        className="profile-cell"
                                    >
                                        <h5 style={{ display: 'flex', alignItems: 'center' }}>
                                            <Image
                                                src={stats.hero_stats_dict && GetHeroImage(getMainHero(stats.hero_stats_dict)?.[0] || '')}
                                                alt={`${player} main`}
                                                size="mini"
                                                style={{ marginRight: '1em' }}
                                            />
                                            {player}
                                        </h5>
                                    </td>
                                    <td>{stats.win_count}</td>
                                    <td>{stats.lose_count}</td>
                                    <td>{getPlayerWinRate(stats)}</td>
                                    <td>{Number(stats.elo).toFixed(2)}</td>
                                </tr>
                            ))
                            }
                        </tbody>

                    </table>
                </div>
            </Container>
        </div>
    );
}

export default PlayerRanks;